import React, {useEffect,useContext,useRef,useState} from "react";
import { useNavigate  } from 'react-router-dom';
import Context from '../context/context';
import CryptoJS from "react-native-crypto-js";
import queryString from 'query-string';
import ReactGA from 'react-ga4';
import helpersFunction from '../_helpers/helpersFunction';
import LanderAutologin from './scaldino_con_autologin';
import AutoLoginDaMail from './autologin_da_mail';


export default function AutoLogin() {
	

	let navigate = useNavigate();
	const context = useContext(Context);
    const firstUpdate = useRef(true);
    const [query, setQuery] = useState();

   
    useEffect(() => {
        firstUpdate.current = false;
        setQuery(queryString.parse(window.location.search))
    },[]); 

    function Render(){

        //ReactGA.event({ category: 'User',action: 'Ritorno da remarketing'})
        
        var redirect = query.red
		var encrypted = query.token
        encrypted = encrypted.replace(/\~/g, '/');
        encrypted = encrypted.replace(/\*/g, '+');
        const remarketingClickid = query.clickid ? query.clickid : "cdc"
        
        try{
            if(encrypted){
                console.log("Encypted OK")
                if(isBase64(redirect)){
                    
                    redirect = window.atob(redirect)
                   
                    let bytes  = CryptoJS.AES.decrypt(encrypted, process.env.REACT_APP_CHIAVE_CRIPTAZIONE);
                    console.log("Decripted:",bytes.toString(CryptoJS.enc.Utf8))
                    let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8)); 
                    
                    if(decryptedData.tipologia === "ccare"){
                        localStorage.setItem('ccare', true)
                    }

                    if(decryptedData.token){
                        localStorage.setItem('token', decryptedData.token)
                        localStorage.setItem('trackerId', decryptedData.trackerId)
                        
                        
                        return (<AutoLoginDaMail red={redirect} angelId={decryptedData.angelId} remarketingClickid={remarketingClickid} reload={firstUpdate.current} clickid={decryptedData.trackerId} contenutoMail={decryptedData.contenutoMail} codiceNotifica={decryptedData.codiceNotifica}/>)
                        
                        


                    }else{
                       
                        helpersFunction.logToBackend("No token su autologin",{decriptedData:decryptedData}).then(res => {
                            navigate('/')
                        })
                        
                    }
                }else{
                    console.log("no base64")
                    helpersFunction.logToBackend("No base64 su autologin",{encripted:encrypted,redirect:redirect}).then(res => {
                        navigate('/find')
                    })
                    
                }
            }else{
                console.log("no encrypt")
                helpersFunction.logToBackend("Codice non criptato su autologin",{encripted:encrypted})
                context.setModalShowHook(true).then(res => {
                    navigate('/find')
                })
                
            }
        }catch(err){
            helpersFunction.logToBackend("Ritorno try catch",{error:err.message}).then(res => {
                navigate('/find')
            })
           
        }
    }

    function isBase64(str) {
        try {
             return btoa(atob(str)) === str ? true : false
        } catch(ex) {
            return false
        }
    }
	
    return (<>
        {query ? (<div><Render /></div>):(<div>Redirecting</div>)}
		</>
	)
}